import { Breadcrumbs, Typography, Link } from "@mui/material";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { usePrincipalControleDocumentosViewModel } from "../../viewModels/principal_controle_documentos_view_model";

import AlertError from "../../../../../common/components/alert_error";
import RefreshButton from "../../../../../common/components/refresh_button";
import { Check, DoNotDisturb, Warning } from "@mui/icons-material";
import StatCard from "../../../../../common/components/statCard";

/**
 * PrincipalControleDocumentos
 */

export const PrincipalControleDocumentos = () => {
  const viewModel = usePrincipalControleDocumentosViewModel();
  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[10rem]">
              </div>
            </div>
          }
        />
      </PageTopBar>

      {/**
        * Page
        */}

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Controle de Documentos
          </Link>
          <Typography className="text-primary-green">
            Principal Controle de Documentos
          </Typography>
        </Breadcrumbs>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white">Principal Controle de Documentos</h1>
            <RefreshButton onClick={viewModel.handleReload} />
          </div>

          <div className="w-full justify-end flex gap-2"></div>
        </div>
        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload} />
              </div>
            ) : (
              <>
                {
                  viewModel.dashboardControleDocumentosInformation !== null && (
                    <div className="w-full flex flex-col gap-8 mb-8">
                      <div className="w-full flex flex-col gap-4 mb-8">
                        <h1 className="text-xl font-bold text-black dark:text-white">Documentos Internos</h1>
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4">
                          <StatCard
                            title='Documentos Atualizados'
                            value={viewModel.dashboardControleDocumentosInformation.documentosInternosAtualizados}
                            icon={Check}
                            colorClass={{
                              bg: 'bg-teal-500',
                              text: 'text-white',
                              bgHover: 'bg-teal-600',
                            }}
                            linkText='Ver detalhes'
                            onClick={() => viewModel.handleCardClick('documentosInternosAtualizados')}
                          />

                          <StatCard
                            title='Documentos Obsoletos'
                            value={viewModel.dashboardControleDocumentosInformation.documentosInternosObsoletos}
                            icon={DoNotDisturb}
                            colorClass={{
                              bg: 'bg-zinc-500',
                              text: 'text-white',
                              bgHover: 'bg-zinc-600',
                            }}
                            linkText='Ver detalhes'
                            onClick={() => viewModel.handleCardClick('documentosInternosObsoletos')}
                          />
                        </div>
                      </div>

                      <div className="w-full flex flex-col gap-4 mb-8">
                        <h1 className="text-xl font-bold text-black dark:text-white">Documentos Externos</h1>
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4">
                          <StatCard
                            title='Documentos Conferência de Atualização'
                            value={viewModel.dashboardControleDocumentosInformation.documentosExternosConferenciaAtualizacao}
                            icon={DoNotDisturb}
                            colorClass={{
                              bg: 'bg-red-500',
                              text: 'text-white',
                              bgHover: 'bg-red-600',
                            }}
                            linkText='Ver detalhes'
                            onClick={() => viewModel.handleCardClick('documentosExternosConferenciaAtualizacao')}
                          />

                          <StatCard
                            title='Documentos Atualizados'
                            value={viewModel.dashboardControleDocumentosInformation.documentosExternosAtualizados}
                            icon={Check}
                            colorClass={{
                              bg: 'bg-teal-500',
                              text: 'text-white',
                              bgHover: 'bg-teal-600',
                            }}
                            linkText='Ver detalhes'
                            onClick={() => viewModel.handleCardClick('documentosExternosAtualizados')}
                          />

                          <StatCard
                            title='Documentos Vencidos'
                            value={viewModel.dashboardControleDocumentosInformation.documentosExternosVencidos}
                            icon={Warning}
                            colorClass={{
                              bg: 'bg-amber-500',
                              text: 'text-white',
                              bgHover: 'bg-amber-600',
                            }}
                            linkText='Ver detalhes'
                            onClick={() => viewModel.handleCardClick('documentosExternosVencidos')}
                          />

                          <StatCard
                            title='Documentos Obsoletos'
                            value={viewModel.dashboardControleDocumentosInformation.documentosExternosObsoletos}
                            icon={DoNotDisturb}
                            colorClass={{
                              bg: 'bg-zinc-500',
                              text: 'text-white',
                              bgHover: 'bg-zinc-600',
                            }}
                            linkText='Ver detalhes'
                            onClick={() => viewModel.handleCardClick('documentosExternosObsoletos')}
                          />
                        </div>
                      </div>
                    </div>
                  )
                }
              </>
            )
        }
      </div>
    </>
  );
}